export default __webpack_public_path__ + "static/media/hiking.98cd07fa.png";